<template>
  <base-modal
    hideFooter
    :size="'lg'"
    @hidden="onCloseModal"
    @show="onModalOpen"
    :modalId="'manage-stock'"
  >
    <template #modal-header>
      <div class="head-label"><b>Manage Stock : </b>{{ formReward.name }}</div>
    </template>
    <div class="w-100 px-2">
      <b-row class="pl-4 pr-2 pb-2">
        <b-col cols="12" lg="8" sm="12">
          <b-row>
            <b-col cols="12">
              <b-form-group
                :label="'Status'"
                label-for="status"
                label-class="font-medium-5"
              >
                <div class="d-flex align-items-center">
                  <feather-icon
                    icon="CircleIcon"
                    class="mr-2"
                    :class="resolveStatusClass(formReward.status)"
                  />

                  <span class="font-medium-5">{{ resolveStatusLabel(formReward.status) }}</span>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6" sm="12">
              <b-row>
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Reference'"
                    label-for="reference"
                    label-class="font-medium-5"
                  >
                    <b-form-input
                      id="reference"
                      required
                      disabled
                      v-model="formReward.reference"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="6" sm="12">
              <b-row class="justify-content-end">
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Privilege Type'"
                    label-for="reward-type"
                    label-class="font-medium-5"
                  >
                    <b-form-input
                      id="reward-type"
                      required
                      disabled
                      v-model="formReward.privilegeType"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6" sm="12">
              <b-row>
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Stock Mode'"
                    label-for="stock-mode"
                    label-class="font-medium-5"
                  >
                    <v-select
                      v-model="formManageStock.stockMode"
                      class="select-format-container font-medium-5"
                      :class="[
                        formManageStock.stockMode
                          ? 'select-format-selected'
                          : null,
                        {},
                      ]"
                      :reduce="(option) => option.value"
                      :options="stockModeOptions"
                      required
                      :disabled="disabledForm.stockMode"
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="6" sm="12">
              <b-row class="justify-content-end">
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Removal Strategy'"
                    label-for="removal-strategy"
                    label-class="font-medium-5"
                  >
                    <v-select
                      v-model="formManageStock.removalStrategy"
                      class="select-format-container font-medium-5 bg-dropdown"
                      :class="[
                        formManageStock.removalStrategy
                          ? 'select-format-selected'
                          : null,
                        {},
                      ]"
                      :reduce="(option) => option.value"
                      :options="removalOptions"
                      required
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="12" sm="12">
              <b-row>
                <b-col cols="12" lg="12" sm="12">
                  <b-form-group :label="`Quantity ( Balance: ${qtyTotal} )`" label-class="font-medium-5">
                    <b-row>
                      <b-col cols="12" lg="3" sm="4">
                        <b-form-radio
                          v-model="selected"
                          name="mode-radios"
                          :value="QUANTITY_ADD"
                          class="custom-radio-group font-medium-5"
                          >Add Quantity</b-form-radio
                        >
                      </b-col>
                      <b-col cols="12" lg="3" sm="4">
                        <input-spin
                          :mode="selected == QUANTITY_ADD ? 'add' : 'disabled'"
                          :numValue="quantityValue.add"
                          @update-number="updateAddQuantity"
                          :key="selected"
                          :isInputDisabled="false"
                        />
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="12" sm="12" v-if="!qtyTotal == 0">
              <b-row>
                <b-col cols="12" lg="12" sm="12">
                  <b-row>
                    <b-col cols="12" lg="3" sm="4">
                      <b-form-radio
                        v-model="selected"
                        name="mode-radios"
                        :value="QUANTITY_WITHDRAW"
                        class="custom-radio-group font-medium-5"
                        >Withdraw</b-form-radio
                      >
                    </b-col>
                    <b-col cols="12" lg="3" sm="4">
                      <input-spin
                        :mode="
                          selected == QUANTITY_WITHDRAW ? 'remove' : 'disabled'
                        "
                        :numValue="quantityValue.withdraw"
                        @update-number="updateWithdraw"
                        :key="selected"
                        :isInputDisabled="false"
                      />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group
                :label="'Note'"
                label-for="note"
                label-class="font-medium-5"
              >
                <b-form-textarea
                  id="note"
                  rows="3"
                  required
                  v-model="formReward.note"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="4" sm="12">
          <img-zoom-content
            :width="'100%'"
            :height="'175px'"
            :imageUrl="formReward.image"
          />
        </b-col>
      </b-row>
      <div class="mt-2 mb-2">
        <div class="d-flex justify-content-center">
          <cancel-button class="mr-1" @click.native="onCloseModal" />
          <save-button
            @click.native="onSubmitPrivilegeToInventory"
            :loading="loading.form"
            class="ml-1"
          />
        </div>
      </div>
    </div>

    <b-row class="modal-body-container mb-1"> </b-row>
  </base-modal>
</template>

<script>
import BaseModal from "@/@core/components/base-modal/BaseModal.vue";
import useManageStockReward from "../hooks/useManageStockReward";
import ImgZoomContent from "../../inventory-privilege-history/components/ImgZoomContent.vue";
import InputSpin from "@/views/components/input-spin/InputSpin.vue";
import { selectAll } from "vue-context/src/js/utils";
export default {
  components: { BaseModal, ImgZoomContent, InputSpin },
  props: {
    rewardDetail: { type: Object, default: {} },
  },
  setup(props) {
    const {
      formReward,
      formManageStock,
      QUANTITY_ADD,
      QUANTITY_WITHDRAW,
      selected,
      quantityValue,
      stockModeOptions,
      removalOptions,
      qtyTotal,
      disabledForm,
      loading,
      onModalOpen,
      updateAddQuantity,
      updateWithdraw,
      onSubmitPrivilegeToInventory,
      resolveStatusLabel,
      resolveStatusClass,
      onCloseModal
    } = useManageStockReward(props);
    return {
      formReward,
      formManageStock,
      QUANTITY_ADD,
      QUANTITY_WITHDRAW,
      selected,
      quantityValue,
      stockModeOptions,
      removalOptions,
      qtyTotal,
      disabledForm,
      loading,
      onModalOpen,
      updateAddQuantity,
      updateWithdraw,
      onSubmitPrivilegeToInventory,
      resolveStatusLabel,
      resolveStatusClass,
      onCloseModal
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/inventory/manage-stock.css";
@import "~@/assets/css/override-styles/radio.css";
</style>
